export default function scheduledReportsDirective() {
  return {
    template: require('./scheduled-reports.html'),
    controller: 'ScheduledReportsController',
    controllerAs: 'scheduledReportsVM',
    bindToController: true,
    replace: true,
  };
}
